import { createI18n } from 'vue-i18n'

const messages = {
  nl: {
    skip_filters: "Filters overslaan",
    navigate_to: "Navigeer naar: ",
    nav_label: "Menu",
    nav_label_close: "Sluit",
    close: "Sluiten",
    page: "Pagina {number}",
    recaptcha_text: 'Dit formulier wordt beschermd door reCAPTCHA en het <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer nofollow">privacybeleid</a> en de <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer nofollow">servicevoorwaarden</a> van Google zijn van toepassing.',
    cookies: {
      change_settings_to_watch_video: 'Pas de cookievoorkeuren aan om deze video te bekijken.',
      change_settings_to_watch_video_adblock: 'De cookie instellingen konden niet worden geladen, klik hier om deze video met cookies te bekijken.',
    },
    slider: {
      previous: "Vorige slide",
      next: "Volgende slide",
    },
    pagination: {
      label: "Paginering",
      previous: "Vorige",
      next: "Volgende",
    },
    search: {
      label: "Zoeken",
      global_placeholder: "Begin met zoeken...",
      close: "Sluit zoekvenster",
    },
    events_overview: {
      filter: "Filter",
      filters: "Filters",
      reset_filters: "Reset filters",
      search: "Zoeken",
      events: "Items",
      results: "resultaten",
      result: "resultaat",
      no_results: "Geen resultaten",
      loading_error: "Er kunnen geen items worden opgehaald, probeer de pagina opnieuw te laden.",
      no_content: "Er kunnen geen resultaten worden gevonden, probeer een andere zoekterm.",
      district: "Wijk",
      month: "Maand",
      last_moment: "Recentste moment",
      upcoming_moment: "Eerstvolgende moment",
      next: "Later",
      next_dates: "Latere momenten",
      prev: "Eerder",
      prev_dates: "Eerdere momenten",
    },
    courses_overview: {
      filter: "Filter",
      filters: "Filters",
      reset_filters: "Reset filters",
      search: "Zoeken",
      find_your_course: "Zoek je cursus",
      courses: "Cursussen",
      results: "resultaten",
      result: "resultaat",
      no_results: "Geen resultaten",
      loading_error: "Er kunnen geen cursussen worden opgehaald, probeer de pagina opnieuw te laden.",
      no_content: "Er kunnen geen resultaten worden gevonden, probeer een andere zoekterm.",
      day: "Dag",
      daypart: "Dagdeel",
      teacher: "Docent",
      various_teachers: "Diverse docenten",
    },
    teachers_overview: {
      filter: "Filter",
      filters: "Filters",
      reset_filters: "Reset filters",
      search: "Zoek op naam of discipline",
      find_your_teacher: "Zoek je docent",
      teachers: "Docenten",
      results: "resultaten",
      result: "resultaat",
      no_results: "Geen resultaten",
      loading_error: "Er kunnen geen docenten worden opgehaald, probeer de pagina opnieuw te laden.",
      no_content: "Er kunnen geen resultaten worden gevonden, probeer een andere zoekterm.",
    },
    filters: {
      label: "Filters",
      close: "Sluit filters",
      discipline: "Discipline",
      show_all: "Toon alles",
      type: "Type",
      district: "Wijk",
      month: "Maand",
      year: "Jaar",
      age: "Leeftijd",
      language_teacher: "Taal docent",
      lesson_plan: "Lesvorm",
      day: "Dag",
      daypart: "Dagdeel",
    },
    tile: {
      new: 'Nieuw!',
      hint: 'Tip!',
      yr: 'jr',
    },
    newsletter: {
      email: {
        label: "E-mailadres",
        placeholder: "E-mailadres...",
      },
      choose: {
        label: "Type nieuwsbrief",
        placeholder: "Kies je nieuwsbrief",
      },
      option_1: "VRIJDAG: cursussen, workshops en activiteiten",
      option_2: "KultuurLoket: nieuws voor en door het culturele veld van Groningen",
      option_3: "VRIJDAG in de Buurt: cultureel nieuws uit de wijken van Groningen",
      option_4: "VRIJDAG Onderwijs: aanbod en nieuws voor PO, VO en BSO",
      submit: "Inschrijven",
      form_label: "Nieuwsbrief inschrijfformulier",
      error: "Er is iets mis gegaan tijdens het aanmelden, probeer het later opnieuw.",
    },
    table: {
      show_more: "Alles tonen",
      show_less: "Minder tonen",
    },
    photoswipe: {
      closeTitle: 'Galerij sluiten',
      zoomTitle: 'Zoomen',
      arrowPrevTitle: 'Vorige in galerij',
      arrowNextTitle: 'Volgende in galerij',
      errorMsg: 'De afbeelding kan niet worden geladen',
    },
    countdown: {
      days: 'dagen',
      day: 'dag',
      hours: 'uren',
      hour: 'uur',
      minutes: 'minuten',
      minute: 'minuut',
      seconds: 'seconden',
      second: 'seconde',
      and: 'en',
    },
    feedback: {
      close: 'Feedback sluiten',
      name: 'Naam',
      mail: 'E-mailadres',
      feedback: 'Feedback',
      send: 'Versturen',
      error: 'Er is een probleem opgetreden tijdens het verzenden van je feedback. Probeer het a.u.b. nog een keer.',
    },
  },

  en: {
    skip_filters: "Skip filters",
    navigate_to: "Navigate to: ",
    nav_label: "Menu",
    nav_label_close: "Close",
    close: "Close",
    page: "Page {number}",
    recaptcha_text: 'This form is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer nofollow">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer nofollow">Terms of Service</a> apply.',
    cookies: {
      change_settings_to_watch_video: 'Change the cookie preferences to view this video.',
      change_settings_to_watch_video_adblock: 'The cookie settings could not be loaded, click here to view this video with cookies.',
    },
    slider: {
      previous: "Previous slide",
      next: "Next slide",
    },
    pagination: {
      label: "Pagination",
      previous: "Previous",
      next: "Next",
    },
    search: {
      label: "Search",
      global_placeholder: "Start searching...",
      close: "Close the search",
    },
    events_overview: {
      filter: "Filter",
      filters: "Filters",
      reset_filters: "Reset filters",
      search: "Search",
      events: "Items",
      results: "results",
      result: "result",
      no_results: "No results",
      loading_error: "No items could be retrieved, please try to load the page again.",
      no_content: "No results could be found, please try another search term.",
      district: "District",
      month: "Month",
      year: "Year",
      last_moment: "Last moment",
      upcoming_moment: "Upcoming moment",
      next: "Later",
      next_dates: "Later dates",
      prev: "Previous",
      prev_dates: "Previous dates",
    },
    courses_overview: {
      filter: "Filter",
      filters: "Filters",
      reset_filters: "Reset filters",
      search: "Search",
      find_your_course: "Find your course",
      courses: "Courses",
      results: "results",
      result: "result",
      no_results: "No results",
      loading_error: "No courses could be retrieved, please try to load the page again.",
      no_content: "No results could be found, please try another search term.",
      day: "Day",
      daypart: "Daypart",
      teacher: "Teacher",
      various_teachers: "Various teachers",
    },
    teachers_overview: {
      filter: "Filter",
      filters: "Filters",
      reset_filters: "Reset filters",
      search: "Search for name or discipline",
      find_your_teacher: "Find your teacher",
      teachers: "Teachers",
      results: "results",
      result: "result",
      no_results: "No results",
      loading_error: "No teachers could be retrieved, please try to load the page again.",
      no_content: "No results could be found, please try another search term.",
    },
    filters: {
      label: "Filters",
      close: "Close filters",
      discipline: "Discipline",
      show_all: "Show all",
      type: "Type",
      district: "District",
      month: "Month",
      age: "Age",
      language_teacher: "Language teacher",
      lesson_plan: "Lesson plan",
      day: "Day",
      daypart: "Daypart",
    },
    tile: {
      new: 'New!',
      hint: 'Hint!',
      yr: 'yr',
    },
    newsletter: {
      email: {
        label: "E-mail address",
        placeholder: "E-mail address...",
      },
      choose: {
        label: "Newsletter type",
        placeholder: "Choose your newsletter",
      },
      option_1: "VRIJDAG: courses, workshops and activities (in dutch)",
      option_2: "KultuurLoket: news for and by the cultural field of Groningen (in dutch)",
      option_3: "VRIJDAG in de Buurt: cultural news from the neighborhoods of Groningen (in dutch)",
      option_4: "VRIJDAG Onderwijs: courses and news for primary, secondary, and after-school education (in dutch)",
      submit: "Submit",
      form_label: "Newsletter subscription form",
      error: "Something went wrong, please try again later.",
    },
    table: {
      show_more: "Show all",
      show_less: "Show less",
    },
    photoswipe: {
      closeTitle: 'Close gallery',
      zoomTitle: 'Zoom',
      arrowPrevTitle: 'Previous in gallery',
      arrowNextTitle: 'Next in gallery',
      errorMsg: 'The image cannot be loaded',
    },
    countdown: {
      days: 'days',
      day: 'day',
      hours: 'hours',
      hour: 'hour',
      minutes: 'minutes',
      minute: 'minute',
      seconds: 'seconds',
      second: 'second',
      and: 'and',
    },
    feedback: {
      close: 'Close feedback',
      name: 'Name',
      mail: 'E-mail address',
      feedback: 'Feedback',
      send: 'Send',
      error: 'There was a problem sending your feedback. Please try again.',
    },
  },
}

const i18n = createI18n({
  locale: "nl",
  messages,
});

export default i18n;
